import type { CSSProperties, ReactNode, RefObject } from 'react';
import { CircleHelp } from 'lucide-react';
import { openHelp } from '../screens/help/help-view';

/**
 * Help, a row of the profile menu above Sign out (gap list C8; Dustin, 2026-10-20): the keys, the tour, the
 * developer docs and Ademero support, in one sheet. The menu closes; the sheet gives the keyboard back to the
 * profile's button. Drawn as the menu's other rows are (Profile.tsx ActionRow).
 */
export function HelpRow({
  index,
  tenantId,
  onClose,
  back,
}: {
  index: number;
  tenantId: string;
  onClose: () => void;
  back: RefObject<HTMLButtonElement | null>;
}): ReactNode {
  return (
    <button
      type="button"
      role="menuitem"
      className="profile__out"
      style={{ '--i': index } as CSSProperties}
      onClick={() => {
        onClose();
        openHelp(tenantId, 'help', back.current);
      }}
    >
      <span className="profile__icon" aria-hidden="true">
        <CircleHelp size={15} />
      </span>
      <span>Help</span>
    </button>
  );
}
